import merge from 'lodash/merge';
import { button } from './components/button';
import { textField } from './components/textfield';
import { switches } from './components/switch';
import { appBar } from './components/appbar';
import { table } from './components/table';
import { checkbox } from './components/checkbox';
import { dialog } from './components/dialog';
import { dataGrid } from './components/data-grid';
import { chip } from './components/chip';
import { select } from './components/select';
import { typography } from './components/typography';
import { datePicker } from './components/date-picker';
// ----------------------------------------------------------------------
export function componentsOverrides(theme) {
    const components = merge(button(theme), textField(theme), switches(theme), appBar(theme), table(theme), dataGrid(theme), dialog(theme), checkbox(theme), chip(theme), select(theme), typography(theme), datePicker(theme));
    return components;
}
